import { render, staticRenderFns } from "./drawer-car.vue?vue&type=template&id=390b4485&"
import script from "./drawer-car.vue?vue&type=script&lang=js&"
export * from "./drawer-car.vue?vue&type=script&lang=js&"
import style0 from "./drawer-car.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports